import React from 'react'
import {
  StatusCard,
  StatusNumber,
  StatusLabel,
  IconArea,
  CardContent,
  StatusCardsContainer
} from './StatusCards.styles'
import { Icon } from '../../shared/ui/Icon'
import { colors } from '../../shared/ui/colors'

interface StatusCardsProps {
  receivedCount: number
  expectedCount: number
  notProvidedCount: number
}

export const StatusCards: React.FC<StatusCardsProps> = ({
  receivedCount,
  expectedCount
}) => {
  return (
    <StatusCardsContainer>
      <StatusCard>
        <IconArea bg={colors.status.received.icon}>
          <Icon type="check" size={16} color="white" />
        </IconArea>
        <CardContent>
          <StatusLabel>Документация утверждена</StatusLabel>
          <StatusNumber>{receivedCount}</StatusNumber>
        </CardContent>
      </StatusCard>

      <StatusCard>
        <IconArea bg={colors.status.expected.icon}>
          <Icon type="exclamation" size={16} color="white" />
        </IconArea>
        <CardContent>
          <StatusLabel>Документация на согласовании</StatusLabel>
          <StatusNumber>{expectedCount}</StatusNumber>
        </CardContent>
      </StatusCard>

      <StatusCard>
        <IconArea bg={colors.status.notProvided.icon}>
          <Icon type="circle" size={16} color="white" />
        </IconArea>
        <CardContent>
          <StatusLabel>Документации нет</StatusLabel>
        </CardContent>
      </StatusCard>
    </StatusCardsContainer>
  )
}
